import React from 'react';
import { Box, Typography } from '@mui/material';
import { TooltipedIcon } from '@europrocurement/flexy-components';
import { demoIcon } from '@europrocurement/l2d-icons';
import { NestedDossierFormaliteOpenSearch } from '@europrocurement/l2d-domain';
import DossierFormaliteLabel from '../DossierFormaliteLabel/DossierFormaliteLabel';

export type DossierCompanyFormalityProps = {
    libelle: string;
    formalites: Array<NestedDossierFormaliteOpenSearch>;
    demo: boolean | null | undefined;
};

const DossierCompanyFormality: React.FunctionComponent<DossierCompanyFormalityProps> = function (
    props,
) {
    const { libelle, formalites, demo = false } = props;

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                {demo && (
                    <TooltipedIcon
                        icon={demoIcon}
                        tooltip="Démo"
                        size="xs"
                        color="error"
                    />
                )}
                <Typography
                    variant="l2dtableCell"
                    color="text.gris70"
                >
                    {libelle}
                </Typography>
            </Box>
            <DossierFormaliteLabel formalites={formalites} />
        </Box>
    );
};

export default DossierCompanyFormality;
